export default __webpack_public_path__ + "static/media/clean-hasmat.03c56c89.jpg";